/* eslint-disable max-len */

type IconTiktokProps = {
  className?: string
  color?: string
}

export const IconTiktok = ({ className, color = '#00BFFF' }: IconTiktokProps) => (
  <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M14.4854 16.4717C14.4854 18.6808 12.6945 20.4717 10.4854 20.4717C8.27622 20.4717 6.48535 18.6808 6.48535 16.4717C6.48535 14.2625 8.27622 12.4717 10.4854 12.4717C10.9354 12.4717 11.3679 12.546 11.7715 12.6831"
      stroke={color}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4854 16.4717V4.97168C14.4854 7.46024 16.4968 9.47168 18.9854 9.47168"
      stroke={color}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
